var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","color":"transparent","data-aos":"fade"}},[_c('v-img',{attrs:{"max-height":"500","lazy-src":_vm.image.lazySrc,"position":_vm.position,"src":_vm.image.src}}),_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))]),_c('v-container',[_vm._t("default")],2),_c('testimonials',{attrs:{"filter":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }